:host {
  display: block;
  width: 100%;
  --ds-prose-text-max-inline-size: var(--dimension-panel-width-lg);
  -webkit-user-select: none;
  user-select: none;
}
.agent-response {
  display: grid;
  gap: var(--dimension-space-150);
  min-width: 0;
  width: 100%;
  -webkit-user-select: none;
  user-select: none;
}
